import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const GoogleCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAuthToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      // OAuth failed
      navigate('/login?error=Google sign-in failed. Please try again.');
      return;
    }

    if (token) {
      // Store token and fetch user info
      localStorage.setItem('token', token);

      // Fetch user info with the token
      fetch(`${process.env.REACT_APP_API_URL || 'https://templimizeai-coursecreatorvault.onrender.com/api'}/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => res.json())
      .then(data => {
        if (data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
          // Use the auth context setter if available
          if (setAuthToken) {
            setAuthToken(token, data.user);
          }
          navigate('/dashboard');
        } else {
          navigate('/login?error=Authentication failed');
        }
      })
      .catch(() => {
        navigate('/login?error=Authentication failed');
      });
    } else {
      // No token received
      navigate('/login?error=Authentication failed');
    }
  }, [searchParams, navigate, setAuthToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50">
      <div className="text-center">
        <div className="inline-block w-16 h-16 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mb-4"></div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Signing you in...</h2>
        <p className="text-gray-600">Please wait while we complete your Google sign-in</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
